import TerraKit from '@terra-js/terra-kit';
import { userManager } from './user.es.js';

const accessTokenInterceptor = (request) => {
  if (typeof window === "undefined")
    return;
  const accessToken = userManager.getAccessToken();
  if (accessToken) {
    request.headers.set("Authorization", `Bearer ${accessToken}`);
  }
};
const getAccessToken = () => userManager.getAccessToken();
let isRefreshing = false;
const handleResponseUnauthorizedInterceptor = (_request, response) => {
  const { code } = response;
  if (typeof window !== "undefined" && code === 401 && TerraKit.isAvailable()) {
    if (isRefreshing)
      return;
    isRefreshing = true;
    Promise.resolve().then(() => TerraKit.auth().refreshAccessToken()).then(() => TerraKit.auth().getAccessTokenAsync()).then((accessToken) => {
      if (accessToken) {
        userManager.setAccessToken(accessToken);
      }
      window.alert("Phi\xEAn \u0111\u0103ng nh\u1EADp v\u1EEBa \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt. Vui l\xF2ng th\u1EF1c hi\u1EC7n l\u1EA1i thao t\xE1c");
      isRefreshing = false;
    }).catch((e) => {
      console.error("refresh access token failed", e);
      isRefreshing = false;
    });
  }
};

export { accessTokenInterceptor, getAccessToken, handleResponseUnauthorizedInterceptor };
